import {TranslationWidth} from '@angular/common';
import {Injectable} from '@angular/core';
import {NgbDatepickerI18n, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';

const LANG_LOCAL: any = {
  ar: 'ar-MA',
  fr: 'fr-FR',
  en: 'en-US',
};

@Injectable()
export class TmwDatepickerI18n extends NgbDatepickerI18n {
  private _locale = 'fr-FR'; //inject(LOCALE_ID);

  private _monthsShort = [...Array(12).keys()].map((month) =>
    Intl.DateTimeFormat(this._locale, {month: 'short', timeZone: 'UTC'}).format(Date.UTC(2000, month)),
  );
  private _monthsFull = [...Array(12).keys()].map((month) =>
    Intl.DateTimeFormat(this._locale, {month: 'long', timeZone: 'UTC'}).format(Date.UTC(2000, month)),
  );

  getWeekdayLabel(weekday: number, width?: Exclude<Intl.DateTimeFormatOptions['weekday'], undefined>): string {
    // 1 MAY 2000 is a Monday
    const weekdays = [1, 2, 3, 4, 5, 6, 7].map((day) =>
      Intl.DateTimeFormat(this._locale, {weekday: 'short', timeZone: 'UTC'}).format(Date.UTC(2000, 4, day)),
    );

    // `weekday` is 1 (Mon) to 7 (Sun)
    return weekdays[weekday - 1] || '';
  }

  getMonthShortName(month: number): string {
    return this._monthsShort[month - 1] || '';
  }

  getMonthFullName(month: number): string {
    return this._monthsFull[month - 1] || '';
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    const jsDate = new Date(date.year, date.month - 1, date.day);
    // return formatDate(jsDate, 'fullDate', this._locale);

    return Intl.DateTimeFormat(this._locale, {dateStyle: 'full', timeZone: 'UTC'}).format(jsDate);
  }

  updateLocal(lang: string) {
    this._locale = LANG_LOCAL[lang];

    this._monthsShort = [...Array(12).keys()].map((month) =>
      Intl.DateTimeFormat(this._locale, {month: 'short', timeZone: 'UTC'}).format(Date.UTC(2000, month)),
    );
    this._monthsFull = [...Array(12).keys()].map((month) =>
      Intl.DateTimeFormat(this._locale, {month: 'long', timeZone: 'UTC'}).format(Date.UTC(2000, month)),
    );
  }
}
